import { ExternalLink, ShoppingBag } from "lucide-react";
import api from "@/lib/api";

function productsOf(game) {
  if (game?.products?.length) return game.products;
  if (game?.product_url) return [{ name: game.product_name, desc: game.product_desc, image: game.product_image, url: game.product_url }];
  return [];
}

export default function GameRecommendation({ game }) {
  const products = productsOf(game);
  if (products.length === 0) return null;

  const openProduct = (p, i) => {
    api.post(`/games/${game.id}/product-click`, { index: i, name: p.name || "" }).catch(() => {});
    window.open(p.url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="space-y-2" data-testid={`game-reco-${game.id}`}>
      {products.map((p, i) => (
        <div key={i} className="rounded-2xl bg-amber-50 border-2 border-amber-200 p-4 flex items-center gap-4" data-testid={`game-reco-item-${game.id}-${i}`}>
          {p.image ? (
            <img src={p.image} alt={p.name || ""} className="w-16 h-16 rounded-xl object-cover border border-amber-200 shrink-0" />
          ) : (
            <span className="w-16 h-16 rounded-xl bg-amber-100 text-amber-600 flex items-center justify-center shrink-0"><ShoppingBag className="w-7 h-7" /></span>
          )}
          <div className="flex-1 min-w-0">
            <p className="font-patient font-bold text-amber-800">{p.name || "Objet recommandé"}</p>
            {p.desc && <p className="text-sm text-gray-600 leading-snug">{p.desc}</p>}
          </div>
          <button onClick={() => openProduct(p, i)} data-testid={`game-reco-link-${game.id}-${i}`}
            className="shrink-0 inline-flex items-center gap-2 h-11 px-4 rounded-full bg-emerald-700 hover:bg-emerald-800 text-white font-patient font-bold transition-colors">
            Découvrir l'objet <ExternalLink className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
}

